import {HeaderProps} from '@ui-kit/src/Header/Header.types';

import {StrapiHeaderRequest} from '@strapi/types';

export const convertStrapiHeaderLinksToProps = (
  links: StrapiHeaderRequest['links'],
): HeaderProps['links'] =>
  // чтобы дропнуть mobileIconCode пока он все еще приходит
  Object.values(links).map(({isTargetBlank, mobileIcon, title, href}) => ({
    title,
    href,
    mobileIcon: mobileIcon?.url,
    target: isTargetBlank ? '_blank' : '_self',
  }));
